import * as z from 'zod';
export const remoteCommandTypeSchema = z.enum([
    'PAUSE',
    'RESUME',
    'ADD_TIME',
    'END_SESSION',
    'LOCK',
    'UNLOCK',
    'REFRESH_CONFIG',
    'REFRESH_CONTENT',
    /** Opens one approved item on the tablet now. Carries `contentItemId`. */
    'PLAY_CONTENT',
]);
/**
 * What to do with a command that arrives while the device is unreachable.
 *
 * The distinction matters: a `PAUSE` delivered three hours late is harmful,
 * whereas `ADD_TIME` is still correct whenever it lands.
 */
export const offlineDeliverySchema = z.enum([
    /** Discard; acting on it later would be wrong. */
    'DROP',
    /** Hold until the device reconnects. */
    'QUEUE',
    /** Hold, but keep only the most recent of its type. */
    'COALESCE',
]);
//# sourceMappingURL=command.js.map